/*
 * Copyright (C) 2020 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export const EShapeState = {
	CLICKED: "CLICKED",
	DBL_CLICKED: "DBL_CLICKED",
	DOWN: "DOWN",
	UP: "UP",
	UP_OUTSIDE: "UP_OUTSIDE",

	RIGHT_CLICKED: "RIGHT_CLICKED",
	RIGHT_DOWN: "RIGHT_DOWN",
	RIGHT_UP: "RIGHT_UP",
	RIGHT_UP_OUTSIDE: "RIGHT_UP_OUTSIDE",
	RIGHT_PRESSED: "RIGHT_PRESSED",

	ACTIVATED: "ACTIVATED",
	DEACTIVATED: "DEACTIVATED"
};
